// Imports
import { initWpAccessibilitySliderFeatures } from './modules/accessibilityImprovement/sliderCarouselOptimization.js';
import { initPopupCloseButtonAriaLabel } from './modules/accessibilityImprovement/popupCloseButtonAriaLabel.js';
import { initAccordeonOptimization } from './modules/accessibilityImprovement/accordeonOptimization.js';
import { initFormErrorOptimization } from './modules/accessibilityImprovement/formErrorOptimization.js';
import { initNavOptimization } from './modules/accessibilityImprovement/navOptimization.js';

document.addEventListener("DOMContentLoaded", function () {
    initWpAccessibilitySliderFeatures();
    initPopupCloseButtonAriaLabel();
    initAccordeonOptimization();
    initFormErrorOptimization();
    initNavOptimization();
});